import './style.scss';

function initHomeIntro(block) {
  if (block.dataset.homeIntroInitialized === 'true') {
    return;
  }

  const video = block.querySelector('[data-home-intro-video]');

  if (!video) {
    return;
  }

  block.dataset.homeIntroInitialized = 'true';

  const sources = Array.from(video.querySelectorAll('source[data-src]'));
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const saveData = Boolean(navigator.connection && navigator.connection.saveData);
  let sourcesLoaded = false;
  let isVisible = false;

  const hydrateVideo = () => {
    if (sourcesLoaded) {
      return;
    }

    sources.forEach((source) => {
      const sourceUrl = source.dataset.src;

      if (sourceUrl) {
        source.src = sourceUrl;
        source.removeAttribute('data-src');
      }
    });

    sourcesLoaded = true;
    video.load();
  };

  const pauseVideo = () => {
    video.pause();
  };

  const playVideo = () => {
    if (!isVisible || document.hidden || reducedMotion.matches || saveData) {
      return;
    }

    hydrateVideo();

    const playPromise = video.play();

    if (playPromise && typeof playPromise.catch === 'function') {
      playPromise.catch(() => {});
    }
  };

  const handleVisibility = (visible) => {
    isVisible = visible;

    if (isVisible) {
      playVideo();
    } else {
      pauseVideo();
    }
  };

  video.muted = true;
  video.defaultMuted = true;

  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        handleVisibility(entry.isIntersecting);
      });
    }, {
      rootMargin: '0px',
      threshold: 0.01,
    });

    observer.observe(block);
  } else {
    const checkVisibility = () => {
      const rect = block.getBoundingClientRect();
      handleVisibility(rect.bottom > 0 && rect.top < window.innerHeight);
    };

    checkVisibility();
    window.addEventListener('scroll', checkVisibility, {passive: true});
    window.addEventListener('resize', checkVisibility, {passive: true});
  }

  document.addEventListener('visibilitychange', () => {
    if (document.hidden) {
      pauseVideo();
    } else if (isVisible) {
      playVideo();
    }
  });

  reducedMotion.addEventListener('change', (event) => {
    if (event.matches) {
      pauseVideo();
    } else if (isVisible) {
      playVideo();
    }
  });
}

export function home_intro(root = document) {
  const selector = '[data-component="home-intro"]';
  const context = root || document;
  const blocks = [];

  if (context.nodeType === 1 && context.matches(selector)) {
    blocks.push(context);
  }

  if (context.querySelectorAll) {
    blocks.push(...context.querySelectorAll(selector));
  }

  blocks.forEach(initHomeIntro);
}
